@if (loading) {
  <ds-localized-spinner dataLoading="true" loadingMessage="Loading..."></ds-localized-spinner>
}
@if (billAccount && !loading) {
  <div class="card-container">
    <div class="top"></div>

    <div class="amt-date-container flex">
      <div>
        <!-- Min Due -->
        <p class="min-due-amt">
          {{ billAccount.minimumAmountDue | strToFloat | currency: 'USD' : 'symbol' : '1.2-2' }}
        </p>

        <!-- Due Date -->
        <p class="due-date">Due {{ billAccount.paymentDueDate | dateFormat: 'MMMM D, YYYY' }}</p>

        <!-- Associated status message -->
        @if (status) {
          <p [ngClass]="status.statusIcon + '-container'">
            @if (status.statusText) {
              <span class="icon" [class]="status.statusIcon"></span>
              <span [ngClass]="{ primaryIconFont: status.statusIcon === 'icon-info' }">{{
                status.statusText
              }}</span>
            }
          </p>
        }
      </div>

      <!-- Associated Action button -->
      @if (status) {
        <div>
          <!-- Balance due pay btn -->
          @if (
            status.actionButton === 'Pay' &&
            showPayBillButton &&
            billAccount?.billingMethod !== onlineBillingText
          ) {
            <button
              ds-button
              authCheck
              [permissionName]="'registerbillacct_walkthrough'"
              [checkAction]="'disable'"
              class="link"
              (click)="registerOrPay()"
              [attr.aria-label]="makePaymentBtnContent"
              data-cy="billAccountPayBillButton"
            >
              {{ payBillContent }}
            </button>
          }

          <!-- Balance due pay btn -->
          @if (
            status.actionButton === 'Pay' &&
            showPayBillButton &&
            billAccount?.billingMethod === onlineBillingText
          ) {
            <button
              ds-button
              authCheck
              [permissionName]="'makemyacctpayment_walkthrough'"
              [checkAction]="'disable'"
              class="link"
              (click)="registerOrPay()"
              [attr.aria-label]="makePaymentBtnContent"
              data-cy="billAccountPayBillButton"
            >
              {{ payBillContent }}
            </button>
          }

          <!-- Single scheduled payment  -->
          @if (
            status.actionButton === 'Edit payment' &&
            metaData.scheduledPayments[0].paymentStatus !== 'AUTHORIZED'
          ) {
            <button
              ds-button
              class="link"
              (click)="editPayment(metaData.scheduledPayments[0].paymentId)"
              [attr.aria-label]="'Edit payment'"
            >
              {{ editPaymentContent }}
            </button>
          }

          <!-- Edit lender -->
          @if (!isAdminApp && thirdPartyInterest.length > 0) {
            <button
              ds-button
              class="link"
              (click)="onEditLender()"
              [attr.aria-label]="'Edit Lender'"
            >
              {{ editLenderBtnContent }}
            </button>
          }

          <!-- Card Expired -->
          @if (!isAdminApp && status.actionButton === 'Update card') {
            <button
              ds-button
              class="link"
              (click)="onUpdateCard()"
              [attr.aria-label]="'Update card'"
            >
              {{ updateCardBtnContent }}
            </button>
          }
        </div>
      }
    </div>

    <div class="inner-card-container">
      <div class="section-container">
        <div class="flex section-header">
          <p>Remaining balance:</p>
          <p>
            {{ billAccount.accountBalance | strToFloat | currency: 'USD' : 'symbol' : '1.2-2' }}
          </p>
        </div>

        <p class="section-content">
          Billing account #: {{ billAccount.billAccountNumber | prettyBillingAcctNum }}
        </p>
      </div>
      <hr class="divider" />

      <!-- Autopay section  -->
      @if (status && metaData && !metaData.hasAFT && !metaData.hasTPIPayer) {
        <div class="section-container">
          <div class="flex section-header">
            <p>
              AutoPay
              @if (metaData.hasAutoPay) {
                <span class="autopay-status-pill on-pill">On</span>
              } @else {
                <span class="autopay-status-pill off-pill">Off</span>
              }
            </p>
            @if (!isAdminApp && !metaData.isReadOnly) {
              @if (metaData.hasAutoPay) {
                <button
                  ds-button
                  class="link"
                  (click)="editAutopay()"
                  [attr.aria-label]="'Edit auto pay'"
                >
                  {{ editAutopayBtnContent }}
                </button>
              } @else {
                <button
                  ds-button
                  class="link"
                  (click)="addAutopay()"
                  [attr.aria-label]="'Edit auto pay'"
                >
                  {{ editAutopayBtnContent }}
                </button>
              }
            }
          </div>

          @if (metaData.automaticPayments) {
            <p class="section-content">
              {{ metaData.automaticPayments.paymentAccount.nickName }}
            </p>
            <p class="section-content">
              {{ autopayDayBeforeContent }}
            </p>
          }
        </div>
        <hr class="divider" />
      }

      <!-- One time payments -->
      @if (status.actionButton === 'View payments') {
        <div class="section-container">
          <div class="flex section-header">
            <p>One-time payments</p>
          </div>

          @if (!onetimePaymentsLoading) {
            @for (futurePayment of futurePayments; track futurePayment.paymentId) {
              <div class="flex section-content space-between">
                <p>
                  ${{ futurePayment.totalPaymentAmount }} on
                  {{ futurePayment.receivedDate | dateFormat: 'MMMM D, YYYY' }}
                </p>
                @if (futurePayment.paymentStatus === 'SCHEDULED') {
                  <button
                    ds-button
                    class="link"
                    (click)="editPayment(futurePayment.paymentId)"
                    [attr.aria-label]="'Edit payment'"
                  >
                    Edit
                  </button>
                }
                @if (futurePayment.paymentStatus === 'AUTHORIZED') {
                  <button
                    ds-button
                    class="link"
                    (click)="view()"
                    [attr.aria-label]="'View payment'"
                  >
                    View
                  </button>
                }
              </div>
            }
          }
          @if (onetimePaymentsLoading) {
            <ds-localized-spinner
              [dataLoading]="true"
              [loadingMessage]="'Loading one time payments...'"
            >
            </ds-localized-spinner>
          }
        </div>

        <hr class="divider" />
      }

      <div class="section-container">
        <div class="flex section-header">
          <p dsContent [contentPath]="'billing.billingReminder.billReminderHeader'"></p>
          @if (!editReminder) {
            <button
              ds-button
              class="link"
              (click)="editReminderFrequency()"
              [attr.aria-label]="'Edit billing reminder'"
              dsContent
              [contentPath]="'billing.billingReminder.editActionLabel'"
            ></button>
          }
        </div>
        @if (showSpinner) {
          <ds-localized-spinner
            dataLoading="true"
            loadingMessage="Loading..."
          ></ds-localized-spinner>
        } @else {
          @if (!editReminder) {
            <p
              class="info-mail"
              dsContent
              [contentPath]="'billing.billingReminder.emailLabel'"
              [options]="{ emailId: (email$ | async) }"
            ></p>
            @if (
              billAccount.billingPreferences.dueDateReminder &&
              billAccount.billingPreferences.dueDateReminder !== -1
            ) {
              <p
                class="info-mail"
                dsContent
                [contentPath]="'billing.billingReminder.whenLabel'"
                [options]="{ when: billAccount.billingPreferences.dueDateReminder }"
              ></p>
            } @else {
              <p
                class="info-mail"
                dsContent
                [contentPath]="'billing.billingReminder.whenNoReminder'"
              ></p>
            }
          } @else {
            <form [formGroup]="billReminderForm">
              <div
                class="reminder-label font-weight-semibold"
                dsContent
                [contentPath]="'billing.billingReminder.remindInfo'"
              ></div>
              <ds-form-control-container [control]="billReminderForm.get('billingReminder')">
                <select id="billingReminder" class="icon fill" formControlName="billingReminder">
                  <option
                    value="-1"
                    dsContent
                    [contentPath]="'billing.billingReminder.noReminderLabel'"
                  ></option>
                  @for (reminderFrequency of billingReminderFrequencies; track reminderFrequency) {
                    <option [value]="reminderFrequency">
                      <span
                        dsContent
                        [contentPath]="'billing.billingReminder.dueDaysInfo'"
                        [options]="{ frequency: reminderFrequency }"
                      ></span>
                    </option>
                  }
                </select>
                <span class="icon-chevron-down"></span>

                <div></div>
              </ds-form-control-container>
              <p
                class="info-mail-small"
                dsContent
                [contentPath]="'billing.billingReminder.emailLabel'"
                [options]="{ emailId: (email$ | async) }"
              ></p>

              <call-to-action
                [disabled]="billReminderForm.invalid"
                [primaryButtonName]="primaryButtonName"
                (primaryEvent)="saveReminderFrequency()"
                [secondaryButtonName]="tertiaryButtonName"
                (secondaryEvent)="cancel()"
                [equalWidthButtons]="true"
              ></call-to-action>
            </form>
          }
        }
      </div>

      @if (isBam) {
        <hr class="divider" />
        <div class="section-container">
          <div class="flex section-header">
            <p>Stop managing account</p>
            <button
              ds-button
              class="link"
              (click)="openModal()"
              [attr.aria-label]="'Stop managing account'"
            >
              Edit
            </button>
          </div>
        </div>
      }
    </div>
  </div>
}
@if (!billAccount) {
  <div class="text-center">
    <h2 class="heading-main pseudo-icon icon-alert error-600-text"></h2>
    <h2 class="error-600-text" data-cy="billAccountCouldNotBeFound">
      Sorry, this billing account could not be found.
    </h2>
    <p class="caption">
      <a dsRouterLink="/overview" data-cy="returnToOverview">Return to the dashboard</a> and try
      navigating to your billing account from there.
    </p>
  </div>
}
@if (billAccount && !loading && thirdPartyInterest.length > 0) {
  <div class="disclaimer">
    <p class="pad-top-20" data-cy="billAccountDisclaimer">{{ billAccountDisclaimer }}</p>
  </div>
}

<ds-modal
  [id]="stopManagingAccountModal"
  [closeOthers]="true"
  [maxWidth]="650"
  (onCloseModalEvent)="closeStopManagingAccountModal()"
>
  <ds-new-bill-account-stop-managing
    [billAccount]="billAccount"
    [unAssociatedAccount]="unAssociatedAccount"
    [deletePreferenceRetry]="matchedBillAccountNotificationState?.deletePrefsRetry"
  ></ds-new-bill-account-stop-managing>
</ds-modal>

<ds-payment-method-modal
  [paymentMethodAddEditConfig]="paymentMethodAddEditConfig$ | async"
  (paymentMethodAddEditCompleteEvent)="paymentMethodAddEditComplete($event)"
>
</ds-payment-method-modal>

<ds-choose-payment-method-modal
  (addCheckingAccountEvent)="addCheckingAccount()"
  (addCreditDebitEvent)="addCreditDebit()"
/>

<ds-add-payment-method-success-modal
  (closeAddPaymentMethodSuccessModalEvent)="closeAddPaymentMethodSuccessModal()"
/>

<ds-add-payment-method-failure-modal />
